module.exports = "/_next/static/images/game-1-phone-avatar-unkown-1acbf5c94959e5369e71619e225ac9b5.jpg";